define('paychex.app.messages/services/Constants',[],
    function () {

        'use strict';

        return {
            MessageListModelServiceName: 'MessageListModelService',
            MessageListDataServiceName: 'MessageListDataService',
            ParseMarkupService: 'ParseMarkupService',
            MessageListPdfGenerationServiceName: 'MessageListPdfGenerationService'
        };
    });

